<template>
  <div class="course-detail">
    <div class="header">
      <header>
        <span class="back" @click="goBack">
          <img src="@/assets/images/return.png" />
        </span>
        <div class="h-title">
          <h3 v-if="top < 30">课程详情</h3>
          <p v-else>
            <span :class="{ active: active == 'tro' }" @click="scrollTo('tro')"
              >详情</span
            >
            <span
              :class="{ active: active == 'list' }"
              @click="scrollTo('list')"
              >大纲</span
            >
            <span
              :class="{ active: active == 'ask' }"
              v-if="detail.course_type == 5 || detail.course_type == 8"
              @click="scrollTo('ask')"
              >问答</span
            >
            <span
              v-if="detail.course_type != 9"
              :class="{ active: active == 'com' }"
              @click="scrollTo('com')"
              >评价</span
            >
          </p>
        </div>
        <p class="right-tabs">
          <span class="cao" @click="share">
            <img src="../../assets/images/share.png" alt />
          </span>
        </p>
      </header>
    </div>
    <div class="index-banner" v-if="detail.banner && detail.banner.length > 0">
      <div class="banner">
        <van-swipe :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="(item, index) in detail.banner" :key="index">
            <img :src="item ? item : '../assets/images/place_image.png'" />
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div class="cd-body" v-show="detail.title">
      <div class="cd-info">
        <p class="info-title">
          {{ detail.title }}
          <i
            class="info-collect"
            :class="{ 'ic-active': detail.is_collect }"
            @click="collect"
          ></i>
        </p>
        <!-- 非面授 -->
        <p class="info-price" v-if="!detail.is_free">
          <icon-price></icon-price>
          <font>{{ detail.price | toFixPrice }}</font>
          <icon-price v-if="detail.underlined_price"></icon-price>
          <font v-if="detail.underlined_price" class="underline">{{
            detail.underlined_price | toFixPrice
          }}</font>
        </p>
        <p class="info-price cd-free" v-else>免费</p>
        <div v-if="detail.course_type != 7">
          <p class="info-com">
            <!-- 点播课/音频/图文/系统-课程详情】无需展示年月日 -->
            <span
              v-if="
                detail.course_type != 5 &&
                detail.course_type != 8 &&
                detail.course_type != 10 &&
                detail.course_type != 9
              "
              >{{ detail.start_play_date | fomartTime("yyyy.MM.dd") }} -
              {{
                detail.end_play_date | fomartTime("yyyy.MM.dd")
              }}&nbsp;&nbsp;|&nbsp;&nbsp;</span
            >
            共{{ detail.total_periods }}课时 &nbsp;&nbsp;|&nbsp;&nbsp;{{
              detail.sales_num
            }}人已购买
          </p>
          <!-- <p v-if="$pub.showPlayType(detail.course_type)"
             class="info-com">开课时间：{{detail.start_play_date | fomartTime('yyyy.MM.dd hh:mm')}} - {{detail.end_play_date | fomartTime('yyyy.MM.dd hh:mm')}}</p> -->
        </div>
        <!-- 面授 -->
        <div style="padding-top: 1.33333vw" v-else>
          <p class="info-com" v-if="detail.store_num < 999999">
            报名上限：{{ detail.store_num }}人 | 剩余名额：{{ detail.stock }}
          </p>
          <p class="info-com">
            报名截止时间：{{
              detail.enter_end_date | fomartTime("yyyy.MM.dd hh:mm")
            }}
          </p>
          <p class="info-com">
            开课时间：{{
              detail.start_play_date | fomartTime("yyyy.MM.dd hh:mm")
            }}
            - {{ detail.end_play_date | fomartTime("yyyy.MM.dd hh:mm") }}
          </p>
          <p class="info-com">
            开课地点：{{
              detail.province_name + detail.district_name + detail.address
            }}
          </p>
        </div>
      </div>
      <div
        class="cd-actives"
        v-if="
          couponList.length ||
          detail.is_vip_course ||
          gifts.length ||
          detail.gifts_integral
        "
      >
        <p>优惠:</p>
        <section>
          <!-- 赠送积分 -->
          <div class="actives-item" v-if="detail.gifts_integral">
            <span>积分</span>
            <span>
              <em>购买可得{{ detail.gifts_integral }}积分</em>
            </span>
          </div>
          <!-- 赠送图书、练习等赠品 -->
          <div class="actives-item" v-if="gifts.length" @click="getGifts">
            <span>赠送</span>
            <span>
              <em v-for="(item, index) in gifts" :key="index"
                >{{ getGiftType(item.gift_type) }}
                <em v-if="index !== gifts.length - 1">、</em>
              </em>
            </span>
            <font>查看</font>
          </div>
          <!-- 领取优惠券 -->
          <div class="actives-item" v-if="couponList.length" @click="getCoupon">
            <span>领券</span>
            <span>
              <em>领取优惠券最多可减</em>
              <icon-price></icon-price>
              <i>{{ max_price | toFixPrice(0) }}</i>
            </span>
            <font>领取</font>
          </div>
          <div class="actives-item" v-if="detail.is_vip_course" @click="goVip">
            <span>VIP</span>
            <span v-if="detail.is_vip_user"
              >您的会员到期日为：{{
                detail.vip_user_end | fomartTime("yyyy.MM.dd")
              }}</span
            >
            <span v-else>免费观看</span>
            <font>{{ detail.is_vip_user ? "续费" : "开通" }}</font>
          </div>
        </section>
      </div>
      <group
        v-if="is_active"
        :list="group_list"
        :info="group_info"
        @updataList="getGroupInfo"
      ></group>
      <div class="cd-teachers com-style" v-if="teachers.length">
        <p class="cd-title">教学团队</p>
        <ul>
          <li
            @click="goTeacher(item.teacher_id)"
            v-for="(item, index) in teachers"
            :key="index"
          >
            <img :src="item.teacher_avatar" />
            <span>{{ item.teacher_name }}</span>
          </li>
        </ul>
      </div>
      <div id="tro" class="cd-tro com-style">
        <p class="cd-title">课程介绍</p>
        <div class="cd-details" v-html="detail.course_details"></div>
      </div>
      <div id="list" class="cd-list com-style">
        <p class="cd-title">课程大纲</p>
        <charpter
          v-if="detail.course_type != 9"
          :charpters="list"
          :detail="detail"
        ></charpter>
        <course-item
          :course="courses"
          :itemStyle="true"
          v-if="detail.course_type == 9"
        ></course-item>
      </div>
      <div
        id="ask"
        class="courseQues com-style"
        v-if="detail.course_type == 5 || detail.course_type == 8"
      >
        <div class="cd-title">
          <span>全部回答</span>
          <div class="title_more" @click="goMoreList()">
            <span>更多</span>
            <van-icon name="arrow" size="13"></van-icon>
          </div>
        </div>
        <CourseQuesItem
          class="askItem"
          @goDetail="goDetail"
          :list="queList"
        ></CourseQuesItem>
      </div>
      <div id="com" class="cd-comment com-style" v-if="detail.course_type != 9">
        <p class="cd-title">课程评论</p>
        <commentItem></commentItem>
      </div>
    </div>
    <template v-if="is_active">
      <p class="notice" v-if="group_info.stock - group_info.sales_num > 0">
        拼团名额剩余{{
          group_info.stock - group_info.sales_num
        }}个，请尽快开团抢购哦
      </p>
      <p v-else class="notice">拼团名额已售罄，可单独购买学习哦</p>
    </template>
    <footer-btn v-if="is_active">
      <div class="btns" slot="btn">
        <div
          class="left-btn"
          :class="{ 'default-btn': group_info.is_join_spell }"
          @click="submit"
        >
          <p class="p1">
            <icon-price size="mini"></icon-price>
            <span>{{ group_info.price | toFixPrice }}</span>
          </p>
          <p>单独购买</p>
        </div>
        <div
          class="right-btn"
          @click="openSpell"
          :class="{
            'default-btn':
              group_info.stock - group_info.sales_num == 0 &&
              !group_info.is_join_spell,
          }"
        >
          <p class="p1">
            <icon-price size="mini"></icon-price>
            <span v-if="group_info.head_price">{{
              group_info.head_price | toFixPrice
            }}</span>
            <span v-else>{{ group_info.spell_price | toFixPrice }}</span>
          </p>
          <p>{{ group_info.is_join_spell ? "查看我的团" : "我要开团" }}</p>
        </div>
      </div>
    </footer-btn>

    <div class="course-btn" v-else>
      <div class="course-btn-service">
        <img src="@/assets/images/service_icon.png" />
        <router-link to="/onlineService">在线客服</router-link>
      </div>
      <div
        class="course-btn-pay"
        :class="{ 'vip-icon': state == 2 }"
        @click="submit"
      >
        {{ state_name[state] }}
      </div>
    </div>
    <!-- <van-button class="course-btn"
                :class="{'vip-icon': state == 2}"
                @click="submit">{{state_name[state]}}</van-button> -->
    <!-- 分享 -->
    <coupon
      ref="coupon"
      :couponList="couponList"
      @setCoupon="setCoupon"
    ></coupon>
    <shareBox v-if="showShare" ref="share"></shareBox>
    <!-- 显示赠品 -->
    <van-popup
      v-model="show_gifts"
      class="popup_gift"
      closeable
      position="bottom"
    >
      <p class="gift_title">赠送商品</p>
      <div v-for="(item, index) in gifts" :key="index">
        <p class="gift_type">{{ getGiftType(item.gift_type) }}</p>
        <div class="gift_name">
          <div
            class="name"
            @click="gift_detail(it)"
            v-for="(it, i) in item.list"
            :key="i"
          >
            {{ it.gift_name }}<i v-if="i != item.list.length - 1">、</i>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import shareBox from "@/components/ShareBox";
import commentItem from "@/components/CommentItem";
import charpter from "@/components/Charpter";
import courseItem from "@/components/CourseItem";
import coupon from "@/components/Coupon";
import CourseQuesItem from "@/components/que_answers/CourseQuesItem";
import { ShopType } from "@/util/enums";
import group from "@/components/group/GroupList";
export default {
  name: "CourseDetail",
  components: {
    shareBox,
    commentItem,
    charpter,
    courseItem,
    coupon,
    group,
    CourseQuesItem,
  },
  data() {
    return {
      top: 0,
      id: "",
      detail: {},
      teachers: [],
      couponList: [],
      gifts: [],
      courses: [],
      list: [],
      qrimg: "",
      active: "",
      state: 0,
      state_name: ["立即报名", "立即学习", "加入学习"],
      max_price: 0,
      showShare: false,
      queList: [],
      loadMoreText: "查看更多",
      group_list: [],
      group_info: {},
      is_active: 0,
      show_gifts: false,
    };
  },
  methods: {
    goBack() {
      if (window.history.length <= 1) {
        this.$router.replace({ name: "Course" });
        return;
      } else {
        this.$router.go(-1);
      }
    },
    async getDetail() {
      await this.$http
        .get(`/api/app/courseInfo/basis_id=${this.id}`)
        .then((res) => {
          this.detail = res.info;
          document.title = this.detail.title;
          this.$store.dispatch("setShare", {
            share_type: 2,
            route: this.$route,
            web_title: this.detail.title,
            web_description: this.detail.course_details,
            mobile_logo: this.detail.cover,
          });
          this.couponList = res.couponList;
          this.teachers = res.teachers;
          this.gifts = res.gifts; //赠品
          if (this.couponList.length) {
            let max_price = 0;
            res.couponList.forEach((item) => {
              if (max_price < item.discounted_price) {
                max_price = item.discounted_price;
              }
            });
            this.max_price = max_price;
          }
          if (res.info.course_type == 9) {
            this.getSysCourse();
          }
          if (res.info.is_buy || res.info.is_join_study) {
            this.state = 1;
          } else {
            if (res.info.is_vip_course && res.info.is_vip_user) {
              this.state = 2;
            }
          }
        });
      this.getGroupInfo();
    },
    getCharpter() {
      this.$http
        .post(`/api/app/courseChapter`, {
          id: this.id,
        })
        .then((res) => {
          this.list = res;
        });
    },
    getSysCourse() {
      this.$http.post(`/api/app/sysCourseList`, { id: this.id }).then((res) => {
        this.courses = res;
      });
    },
    share() {
      if (this.$pub.checkLogin(true, "push")) {
        this.showShare = true;
        this.$nextTick(() => {
          this.$refs.share.showModel();
        });
      }
    },
    collect() {
      if (!this.detail.is_collect) {
        this.$http
          .post(`/api/app/collect`, {
            course_basis_id: this.id,
            type: 1,
          })
          .then(() => {
            this.$toast({
              message: "收藏成功",
              type: "success",
              duration: 1000,
            });
            this.detail.is_collect = 1;
            // this.getDetail();
          });
      } else {
        this.$http
          .put(`/api/app/collect/cancel/${this.detail.collect_id}/1`)
          .then(() => {
            this.$toast({
              message: "取消收藏",
              duration: 1000,
            });
            this.detail.is_collect = 0;
            // this.getDetail();
          });
      }
    },
    getCoupon() {
      this.$refs.coupon.showModel();
    },
    getGifts() {
      this.show_gifts = true;
    },
    setCoupon(index) {
      this.couponList[index].is_can_get = 0;
    },
    goVip() {
      this.$router.push({
        name: "Vip",
      });
    },
    goTeacher(id) {
      this.$router.push({
        name: "Teacher",
        query: {
          id: id,
        },
      });
    },
    handleScroll() {
      this.top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let a_h = window.$("#tro").offset().top - 45;
      let l_h = window.$("#list").offset().top - 45;
      let r_h = window.$("#com").offset().top - 45;
      let k_h = 0;
      if (this.detail.course_type == 5 || this.detail.course_type == 8) {
        k_h = window.$("#ask").offset().top - 45;
      }
      if (this.top <= a_h) {
        this.active = "tro";
      } else if (this.top <= l_h) {
        this.active = "list";
      } else if (
        this.top <= k_h &&
        (this.detail.course_type == 5 || this.detail.course_type == 8)
      ) {
        this.active = "ask";
      } else if (this.top >= r_h) {
        this.active = "com";
      }
    },
    scrollTo(name) {
      this.active = name;
      let h = window.$(`#${name}`).offset().top - 45;
      window.$("html,body").animate({ scrollTop: h }, 500);
    },
    caskList() {
      // if (this.loadMoreText == '查看更多') {
      this.$http
        .get(`/api/app/ask/caskList`, { course_id: this.id, limit: 5 })
        .then((res) => {
          if (res.list.length > 0) {
            this.queList = this.queList.concat(res.list);
            if (res.list.length < 15) {
              this.loadMoreText = "已加载全部";
            }
          } else {
            this.loadMoreText = "已加载全部";
          }
        });
      // }
    },
    /**
     * 开团
     *  */
    async openSpell() {
      if (this.$pub.checkLogin(true, "push")) {
        if (this.group_info.is_join_spell) {
          // 查看我的团
          this.$router.push({
            name: "GroupDetail",
            query: {
              group_id: this.group_info.group_id,
            },
          });
        } else {
          let flag = await this.$store.dispatch("CheckSpell", {
            spell_id: this.group_info.id,
          });
          if (flag) {
            this.$router.push({
              name: "Purchase",
              query: {
                id: this.$route.query.id,
                type: this.detail.course_type,
                spell_id: this.group_info.id,
                group_id: 0,
              },
            });
          }
        }
      }
    },
    submit() {
      if (this.$pub.checkLogin(true, "push")) {
        if (this.state == 0) {
          //购买 免费课
          // if (this.detail.is_free) {
          //   this.$http
          //     .post(`/api/app/order/downOrder`, {
          //       shop_id: this.id,
          //       type: this.detail.course_type
          //     })
          //     .then(() => {
          //       this.$toast({
          //         message: "成功",
          //         type: "success",
          //         duration: 1000
          //       });
          //       this.getDetail();
          //     });
          // } else {
          // 收费
          if (
            this.detail.stock == 0 &&
            this.detail.store_num > 0 &&
            (this.detail.course_type == 7 || this.detail.course_type == 3)
          ) {
            this.$toast({
              message: "你来晚了哦,名额已经没有了~",
              duration: 1500,
            });
            return;
          }
          this.$router.push({
            name: "Purchase",
            query: {
              id: this.id,
              type: this.detail.course_type,
            },
          });
          // }
        } else if (this.state == 2) {
          // 加入学习
          this.$http
            .post(`/api/app/joinStudy`, {
              course_basis_id: this.id,
              order_id: 0,
              join_from: 1,
              course_type: this.detail.course_type,
            })
            .then(() => {
              this.$toast({
                message: "成功",
                type: "success",
                duration: 1000,
              });
              this.getDetail();
            });
        } else {
          // 立即学习
          this.$router.push({
            name: "MyStudyDetail",
            query: {
              course_id:
                this.detail.course_type == 9 ? this.courses[0].id : this.id,
            },
          });
        }
      }
    },
    init() {
      this.id = this.$route.query.id;
      this.getDetail();
      this.getCharpter();
      this.caskList();
    },
    /**
     * 拼团信息
     *  */
    async getGroupInfo() {
      let group_info = await this.$http.get(
        `/api/app/spellGroupInfo/${this.id}/course`
      );
      if (!Array.isArray(group_info) && group_info.res != 0) {
        // 该用户已经加入拼团，并且团成 / 已经单独购买过， 不显示拼团信息
        if (
          (group_info.is_join_spell && group_info.group_status == 1) ||
          (this.detail.is_buy == 1 && !group_info.is_join_spell)
        ) {
          this.is_active = 0;
        } else {
          this.is_active = 1;
          let data = await this.$http.get(
            `/api/app/spellGroup/${group_info.id}`
          );
          data.list.forEach((item) => {
            item.surpTime = item.end_time - Date.parse(new Date()) / 1000;
          });
          this.group_list = data.list;
        }
      }
      this.group_info = group_info;
    },
    goMoreList() {
      this.$router.push({
        name: "CourseAskList",
        query: { id: this.id, is_buy: this.detail.is_buy },
      });
    },
    goDetail(item) {
      if (this.detail.is_buy === 1) {
        let query = this.$route.query;
        query.is_buy = this.detail.is_buy;
        this.$pub.toAskDetail(query, item);
      } else {
        this.$toast("请先购买课程");
      }
    },
    getGiftType(val) {
      return ShopType.getValue(val);
    },
    // 跳转赠品详情
    gift_detail(item) {
      let param = { name: "BookDetail", query: { id: item.gift_id } };
      if (item.gift_type == 16) {
        //模拟考试
        param.name = "ExamDetail";
      } else if (item.gift_type == 15) {
        //章节练习
        param.name = "ExerciseDetail";
      }
      if ((item.gift_type && !item.is_hidden) || item.gift_type != 12) {
        this.$router.push(param);
      }
    },
  },
  created() {
    this.init();
  },
  watch: {
    $route(val, old) {
      if (val.query.id != old.query.id) {
        this.init();
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
/deep/ .btns {
  width: 688px;
  height: 74px;
  margin: 13px auto;
  border-radius: 37px;
  overflow: hidden;
  display: flex;
  .left-btn {
    width: 346px;
    height: 69px;
    padding-top: 5px;
    background: #ecf0ff;
    color: $theme_color;
    p {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 32px;
      text-align: center;
    }
    .p1 {
      font-size: 26px;
    }
  }
  .right-btn {
    width: 346px;
    height: 69px;
    background: $theme_color;
    padding-top: 5px;
    color: #fff;
    p {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 32px;
      text-align: center;
    }
    .p1 {
      font-size: 26px;
    }
  }
  .default-btn {
    color: #8c8c8c;
    background: rgba(244, 244, 244, 1);
  }
}
.course-detail {
  width: 100%;
  overflow: hidden;
}
.vip-icon::after {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  background: url("../../assets/images/vip-use-btn.png") no-repeat;
  background-size: 100% 100%;
  width: 88px;
  height: 88px;
}
.header {
  height: 88px;
  line-height: 88px;
  border-bottom: 1px solid #f0f2f5;
  header {
    @extend %flex-center;
    height: 88px;
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    z-index: 9;
    background: #fff;
  }
  .header_box {
    width: 100%;
    height: 100%;
  }
  .back {
    @extend %flex-center;
    width: 50px;
    height: 100%;
    padding-left: 20px;
    img {
      width: 18px;
      height: 32px;
    }
  }
  .h-title {
    flex: 2;
    h3 {
      text-align: center;
      font-size: 36px;
      color: #595959;
    }
    p {
      display: flex;
      justify-content: center;
      padding: 0 30px;
      span {
        width: 33.33%;
        text-align: center;
        font-size: 30px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(140, 140, 140, 1);
      }
      span.active {
        color: #333;
        font-weight: 500;
        font-size: 32px;
      }
    }
  }

  .right-tabs {
    width: 60px;
    display: flex;
    align-items: center;
    height: 100%;
    box-sizing: border-box;
    & span {
      &.cao {
        width: 40px;
        height: 44px;
        padding: 10px;
        img {
          width: 30px;
          height: 34px;
          margin-top: 5px;
          display: block;
        }
      }
    }
    .ic-active {
      background: url("../../assets/theme-img/icon-star.png") no-repeat center
        center;
      background-size: 36px 36px;
    }
  }
}
.cd-body {
  background: #f0f2f5;
  padding-bottom: 100px;
  box-sizing: border-box;
  min-height: 92vh;
}
.index-banner {
  position: relative;
  .van-swipe {
    height: 418px;
    overflow: hidden;
  }
  .banner {
    height: 418px;
    position: relative;
    background-position: center center;
    background-size: cover;
    .images {
      width: 100%;
      height: 100%;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.cd-info {
  padding: 30px;
  background: #fff;
  position: relative;
  .info-title {
    font-size: 32px;
    font-family: PingFangSC-Medium;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    padding-right: 80px;
    line-height: 46px;
    .info-collect {
      position: absolute;
      right: 30px;
      top: 20px;
      width: 50px;
      height: 50px;
      background: url("../../assets/images/collections_grey.png") no-repeat
        center center;
      background-size: 36px 36px;
    }
    .ic-active {
      background: url("../../assets/theme-img/icon-star.png") no-repeat center
        center;
      background-size: 36px 36px;
    }
  }
  .info-price {
    font-size: 34px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(238, 31, 31, 1);
    line-height: 64px;
    span {
      font-size: 24px;
    }
    /deep/ .price-ico {
      width: 16px;
      margin: 0 8px;
    }
    .underline {
      font-size: 26px;
      color: #999;
      text-decoration: line-through;
    }
  }
  .cd-free {
    color: $theme_color;
  }
  .info-com {
    font-size: 24px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 60px;
    font {
      &:nth-child(2) {
        padding-left: 12px;
      }
    }
  }
}
.cd-actives {
  display: flex;
  padding: 30px;
  margin-top: 30px;
  background: #fff;
  p {
    width: 80px;
    font-size: 24px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(140, 140, 140, 1);
  }
  section {
    flex: 1;
    .actives-item {
      display: flex;
      align-items: center;
      /deep/ .price-ico {
        width: 22px;
        margin-left: 5px;
      }
      // &:nth-child(1) {
      padding-bottom: 20px;
      // }
      span {
        &:first-child {
          width: 70px;
          height: 32px;
          line-height: 32px;
          background: linear-gradient(
            90deg,
            rgba(206, 184, 156, 1) 0%,
            rgba(163, 130, 89, 1) 100%
          );
          border-radius: 6px;
          font-size: 20px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(38, 38, 38, 1);
          text-align: center;
          margin-right: 14px;
        }
        &:nth-child(2) {
          flex: 1;
          font-size: 24px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(89, 89, 89, 1);
          i {
            color: #ea7a2f;
          }
        }
      }
      font {
        font-size: 24px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(140, 140, 140, 1);
        padding-right: 24px;
        background: url("../../assets/images/icon-go.png") no-repeat right
          center;
        background-size: 16px 28px;
      }
    }
  }
}
.notice {
  height: 54px;
  line-height: 54px;
  position: fixed;
  bottom: 100px;
  left: 0;
  right: 0;
  background: #f4f4f4;
  font-size: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(140, 140, 140, 1);
  text-align: center;
}
.cd-title {
  font-size: 30px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(38, 38, 38, 1);
  padding-top: 20px;
}
.askItem {
  margin-top: 20px;
  /deep/.news-content {
    padding: 0;
    li {
      padding-left: 0;
      padding-right: 0;
    }
  }
}
.title_more {
  float: right;
  font-size: 22px;
  color: #999;
  height: 30px;
  line-height: 30px;
  vertical-align: middle;
  span {
    display: inline-block;
    margin-top: -2px;
    vertical-align: top;
  }
  i {
    margin-top: -6px;
  }
}
.com-style {
  margin-top: 30px;
  background: #fff;
  padding: 10px 20px;
}
.cd-teachers {
  ul {
    display: flex;
    flex-wrap: wrap;
    padding: 20px 0;
    li {
      padding: 20px 0;
      width: 20%;
      height: 180px;
      display: flex;
      align-items: center;
      flex-direction: column;
      box-sizing: border-box;
      img {
        width: 78px;
        height: 78px;
        border-radius: 50%;
      }
      span {
        padding: 16px 6px 0;
        padding-top: 16px;
        font-size: 24px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(89, 89, 89, 1);
      }
    }
  }
}
.cd-tro {
  .cd-details {
    font-size: 28px;
    padding: 30px 10px;
    /deep/ p {
      width: 100%;
    }
    /deep/ img {
      width: 100% !important;
      display: block;
      border: none;
    }
    /deep/ video {
      width: 100%;
    }
  }
}
.courseQues {
  p {
    text-align: center;
    font-size: 24px;
    color: #999;
    height: 40px;
    line-height: 40px;
  }
}
.popup_gift {
  color: #333;
  font-size: 30px;
  padding-bottom: 50px;
  .gift_title {
    height: 110px;
    line-height: 110px;
    text-align: center;
    width: 690px;
    margin-left: 30px;
    border-bottom: 1px solid #f6f6f6;
  }
  .gift_type {
    height: 80px;
    line-height: 80px;
    font-size: 28px;
    padding-left: 30px;
    margin-top: 20px;
  }
  .gift_name {
    font-size: 24px;
    color: #666666;
    padding-left: 30px;
    padding-right: 20px;
    line-height: 36px;
    .name {
      word-break: break-all;
    }
  }
}
.course-btn {
  position: fixed;
  height: 88px;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #fff;
  line-height: 88px;
  font-size: 32px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  .course-btn-service {
    box-shadow: 0px 0px 7px 0px rgba(2, 108, 204, 0.06);
    width: 100%;
    text-align: center;
    a {
      color: #666666;
    }
    img {
      width: 34px;
      height: 32px;
      margin-right: 14px;
    }
  }
  .course-btn-pay {
    width: 100%;
    background: $theme_color;
    text-align: center;
    color: #fff;
  }
}
</style>
